import { AxiosResponse } from 'axios'
import axios from '@/services/axios'

export default abstract class CurrenciesApi {
  public static route = process.env.VUE_APP_SHOP_V2_BASE_URI
  public static entity = 'currencies'

  public static async list(): Promise<AxiosResponse> {
    return await axios.get(`${this.route}/${this.entity}`)
  }

  public static async getArenaCurrencies(
    arenaId: string,
  ): Promise<AxiosResponse> {
    return await axios.get(`${this.route}/arenas/${arenaId}/${this.entity}`)
  }

  public static async addArenaCurrency(
    arenaId: string,
    currency_id: string,
  ): Promise<AxiosResponse> {
    return await axios.post(`${this.route}/arenas/${arenaId}/${this.entity}`, {
      currency_id,
    })
  }
}
